import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import * as _ from "lodash";

if (store.getters["auth/isLoggedIn"]) {
    store.dispatch("permission/getPermissions");
}

Vue.use(Router);
const router = new Router({
    mode: "history",
    scrollBehavior: () => ({
        y: 0,
    }),
    routes: [
        {
            path: "/login",
            name: "login",
            component: () => import("./views/Pages/Login"),
            meta: {
                suspendAllow: true,
            },
        },
        {
            path: "/forgot-password",
            name: "forgot-password",
            component: () => import("./views/Pages/ForgotPassword"),
            meta: {
                suspendAllow: true,
            },
        },
        {
            path: "/passwordless-login",
            name: "passwordless-login",
            component: () => import("./views/Pages/PasswordlessLogin"),
            meta: {
                suspendAllow: true,
            },
        },
        {
            path: "/reset-password",
            name: "reset-password",
            component: () => import("./views/Pages/ResetPassword"),
            meta: {
                suspendAllow: true,
            },
        },
        {
            path: "/",
            meta: { requiresAuth: true },
            component: () => import("./layouts/Panel"),
            children: [
                {
                    path: "/",
                    name: "home",
                    redirect: (to) => {
                        if (store.state.auth.adminUser != null) {
                            return "cluster-dashboard";
                        } else {
                            return "chat";
                        }
                    },
                },
                {
                    path: "denied",
                    name: "permission",
                    component: () => import("./views/Pages/PermissionDenided"),
                    meta: {
                        title: "İzin Yok!",
                    },
                },
                {
                    path: "coklu-oturum",
                    name: "multi_session",
                    component: () => import("./views/Pages/MultiSessionDenied"),
                    meta: {
                        title: "Çoklu oturum tespit edildi!",
                    },
                },
                {
                    path: "chat",
                    name: "chat",
                    component: () => import("./views/Pages/Chat"),
                    meta: {
                        title: "Chat",
                        permission: "chat.get",
                    },
                },
                {
                    path: "/integrations/whatsapp",
                    name: "whatsapp",
                    component: () => import("./views/Pages/WhatsappIntegration"),
                    meta: {
                        title: "Whatsapp",
                    },
                },
                {
                    path: "chatbot",
                    name: "chatbot",
                    component: () => import("./views/Pages/ChatBot"),
                    meta: {
                        title: "ChatBot",
                        permission: "chatbot",
                    },
                },
                {
                    path: "ticket",
                    name: "ticket",
                    component: () => import("./views/Pages/Ticket"),
                    meta: {
                        title: "Ticket",
                        permission: "ticket",
                    },
                },
                {
                    path: "archives",
                    name: "archives",
                    component: () => import("./views/Pages/Archives"),
                    meta: {
                        title: "Arşiv",
                        permission: "archives.get",
                    },
                },
                {
                    path: "offline-support-requests",
                    name: "offline-support-requests",
                    component: () => import("./views/Pages/OfflineSupportRequests"),
                    meta: {
                        title: "Offline Support Requests",
                        permission: "archives.get",
                    },
                },
                {
                    path: "roller",
                    name: "roles",
                    component: () => import("./views/Pages/Roles"),
                    meta: {
                        title: "Roller",
                        permission: "role.get",
                    },
                },
                {
                    path: "kullanicilar",
                    name: "users",
                    component: () => import("./views/Pages/Users"),
                    meta: {
                        title: "Kullanıcılar",
                        permission: "user.get",
                    },
                },
                {
                    path: "konular",
                    name: "subjects",
                    component: () => import("./views/Pages/Subjects"),
                    meta: {
                        title: "Konular",
                        permission: "topic.get",
                    },
                },
                {
                    path: "hazir-icerikler",
                    name: "contents",
                    component: () => import("./views/Pages/Contents"),
                    meta: {
                        title: "Hazır İçerikler",
                        permission: "prepared.get",
                    },
                },
                {
                    path: "karsilama-mesajlari",
                    name: "welcome_messages",
                    component: () => import("./views/Pages/WelcomeMessages"),
                    meta: {
                        title: "Karşılama Mesajları",
                        permission: "welcome.get",
                    },
                },
                {
                    path: "katalog",
                    name: "catalog",
                    component: () => import("./views/Pages/Catalog"),
                    meta: {
                        title: "Katalog",
                        permission: "catalog.get",
                    },
                },
                {
                    path: "yasakli-kelimeler",
                    name: "banned_words",
                    component: () => import("./views/Pages/BannedWords"),
                    meta: {
                        title: "Yasaklı Kelimeler",
                        permission: "bannedWord.get",
                    },
                },
                {
                    path: "yasakli-ziyaretciler",
                    name: "banned_visitors",
                    component: () => import("./views/Pages/BannedVisitors"),
                    meta: {
                        title: "Yasaklı Ziyaretçiler",
                        permission: "bannedVisitor.view",
                    },
                },
                {
                    path: "uygulamalar",
                    name: "apps",
                    component: () => import("./views/Pages/Apps"),
                    meta: {
                        title: "Uygulamalar",
                        permission: "",
                    },
                },
                {
                    path: "ayarlar",
                    name: "settings",
                    component: () => import("./views/Pages/Settings"),
                    meta: {
                        title: "Ayarlar",
                        permission: "setting.get",
                    },
                },
                {
                    path: "billing",
                    name: "billing",
                    component: () => import("./views/Pages/Billing"),
                    meta: {
                        title: "Fatura & Plan",
                        permission: "setting.get",
                        suspendAllow: true,
                    },
                },
                {
                    path: "report-new",
                    name: "report-new",
                    component: () => import("./views/Reports"),
                },
                {
                    path: "admin-users",
                    name: "adminUsers",
                    component: () => import("./views/Pages/AdminUsers"),
                    meta: {
                        title: "Admin Kullanıcılar",
                        isAdmin: true,
                    },
                },
                {
                    path: "/sites/:siteAddress",
                    name: "site-details",
                    component: () => import("./views/Pages/SiteDetail"),
                    meta: {
                        title: "Site Detail",
                        isAdmin: true,
                    },
                },
                {
                    path: "sites",
                    name: "sites",
                    component: () => import("./views/Pages/Sites"),
                    meta: {
                        title: "Siteler",
                        isAdmin: true,
                    },
                },
                {
                    path: "cluster-dashboard",
                    name: "cluster-dashboard",
                    component: () => import("./views/Pages/ClusterDashboard"),
                    meta: {
                        title: "Cluster Dashboard",
                        isAdmin: true,
                    },
                },
                {
                    path: "invoices",
                    name: "invoices",
                    component: () => import("./views/Pages/Invoices"),
                    meta: {
                        title: "Invoices",
                        isAdmin: true,
                    },
                },
                {
                    path: "global-settings",
                    name: "globalSettings",
                    component: () => import("./views/Pages/GlobalSettings"),
                    meta: {
                        title: "Ayarlar",
                        isAdmin: true,
                    },
                },
                {
                    path: "ErrorReports",
                    name: "ErrorReports",
                    component: () => import("./views/Pages/ErrorReports"),
                    meta: {
                        title: "ErrorReport",
                        isAdmin: true,
                    },
                },
                {
                    path: "/install-code",
                    name: "InstallCode",
                    component: () => import("./views/Pages/InstallationInstarctionPage"),
                    meta: {
                        title: "Installation",
                        isAdmin: false,
                        requiresAuth: false,
                        permission: "chat.get",
                    },
                },
            ],
        },
    ],
});

router.beforeEach((to, from, next) => {
    try {
        const isLoggedIn = store.getters["auth/isLoggedIn"],
            authRequired = to.matched.some((record) => _.get(record, "meta.requiresAuth", false)),
            isRoot = store.getters["auth/isRoot"],
            permission = _.get(to, "meta.permission", null),
            userPermissions = _.get(store.state.auth.user, "role.permissions", []);

        if (!isLoggedIn && authRequired) return next({ name: "login", query: { redirect: to.fullPath } });
        if (!!permission && !isRoot && userPermissions.find((p) => p.name !== permission))
            return next({ name: "permission" });
        if (store.getters["site/isSuspend"] && !_.get(to, "meta.suspendAllow", false) && !store.state.auth.adminUser)
            return next({ name: "billing" });
        return next();
    } catch (e) {
        console.error("beforeEach error", e);
        next();
    }
});

export default router;
